import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import SoundManagerEvent from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManagerEvent";
import TextUtil from "../../../../../lib/html5-software-library/src/ranj/components/text/TextUtil";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractPopupMediator from "../../ui/AbstractPopupMediator";
import ClickEaterFactory from "../../ui/ClickEaterFactory";

export default class AudioSubtitlePopupMediator extends AbstractPopupMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {SoundManager} soundManager 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, soundManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._soundManager = soundManager;

        this._handleAudioCueChangedBound = this._handleAudioCueChanged.bind(this);
    }

    initialize() {
        super.initialize();

        this._subtitleTextField = this._target.subtitleTextField;
        this._subtitleTextField.initialY = this._subtitleTextField.y;
        this._subtitleTextField.initialHeight = this._subtitleTextField.getMeasuredHeight();
        this._setSubtitleText(this.getCustomData().initialSubtitleText || '');

        this._addEventListeners();
    }

    destroy() {
        super.destroy();

        this._removeEventListeners();
    }

    _setSubtitleText(text) {
        this._subtitleTextField.text = text;
        TextUtil.centerTextVertically(this._subtitleTextField, this._subtitleTextField.initialY, this._subtitleTextField.initialHeight);
    }

    _addEventListeners() {
        this._soundManager.addEventListener(SoundManagerEvent.AUDIO_CUE_CHANGED, this._handleAudioCueChangedBound);
    }

    _removeEventListeners() {
        this._soundManager.removeEventListener(SoundManagerEvent.AUDIO_CUE_CHANGED, this._handleAudioCueChangedBound);
    }

    _handleAudioCueChanged(evt) {
        const activeCues = evt.activeCues;
        if (activeCues.length === 0) {
            this._setSubtitleText('');
        } else {
            // Note: It is always showing the first cue active, so if you have overlapping cues, the first cue has to end before showing the newer one.
            this._setSubtitleText(activeCues[0].text);
        }
    }
}